import React, { useState, useEffect } from 'react';
import { useTable, useFilters, useSortBy, usePagination, useGlobalFilter } from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SERVER_BASE } from "../config/server";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faEllipsisV, faEye, faFileInvoice, faCheckCircle, faPen, faPlus } from '@fortawesome/free-solid-svg-icons';
import apiClient from "../utils/apiClient";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const GlobalFilter = ({ filter, setFilter }) => (
  <div className="w-100">
    <input
      value={filter || ''}
      className="form-control"
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder="Search..."
    />
  </div>
);
const ReturnAcceptanceTable = ({ accessOfDepartments, permissions }) => {

  const [activeTab, setActiveTab] = useState('table1');
  const navigate = useNavigate();
  const [returnSlips, setReturnSlips] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    apiClient
      .get(`${SERVER_BASE}/getReturnSlips`)
      .then((res) => {
        const filtered = res.data.filter(
          (rs) =>
            accessOfDepartments.includes(rs.receivingDepartment) ||
            accessOfDepartments.includes(rs.issuingDepartment)
        );

        setReturnSlips(filtered);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));

  }, [accessOfDepartments]);

  const handleReturnSlipView = (row) => {
    navigate("../../ReturnSlipPreview", { state: { id: row.id } });
  };
  const handleReturnAcceptanceView = (row) => {
    navigate("../../ReturnAcceptancePreview", { state: { id: row.id } });
  };
  const TableComponent = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      page,
      nextPage,
      previousPage,
      canNextPage,
      canPreviousPage,
      pageOptions,
      gotoPage,
      setPageSize,
      state,
      setGlobalFilter,
    } = useTable(
      {
        columns,
        data,
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
      usePagination
    );

    const { pageIndex, pageSize, globalFilter } = state;

    return (
      <div>
        <div className="d-flex justify-content-between gap-2 mb-3">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="form-select"
            style={{ width: "12%" }}
          >
            {[20, 30, 50, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
        <table {...getTableProps()} className="table table-striped" style={{ fontSize: '14px' }}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="pagination d-flex align-items-center justify-content-between ">

          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="btn btn-secondary"
          >
            Previous
          </button>
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="btn btn-secondary"
          >
            Next
          </button>

        </div>


      </div>
    );
  };

  const Table1 = () => {
    const pendingAcceptance = React.useMemo(() => {
      return returnSlips.filter(rs => rs.status === "Returned");
    }, [returnSlips]);


    const columns = React.useMemo(
      () => [
        { Header: 'RS Number', accessor: 'returnSlipCode' },
        { Header: 'Requesting Department', accessor: 'receivingDepartment' },
        { Header: 'Issuing  Department', accessor: 'issuingDepartment' },
        {
          Header: "Items",
          accessor: "interDepartmentReturnSlipItems",
          Cell: ({ value }) => {
            if (!Array.isArray(value) || value.length === 0) return "-";

            return value
              .map(i => i.item || i.itemName || i.printName)
              .filter(Boolean)
              .join(", ");
          }
        },
        { Header: 'Status', accessor: 'status' },
        // { Header: 'Items', accessor: 'items' },
        {
          Header: 'Preview', accessor: 'Preview', Cell: ({ row }) => {
            return (
              permissions?.read &&
              <button
                className="btn btn-sm btn-outline-success me-1"
                onClick={() => handleReturnSlipView(row.original)}
              >
                <FontAwesomeIcon icon={faEye} /> View
              </button>
            )
          }
        },
        {
          Header: "#",
          accessor: "actions",
          Cell: ({ row }) => (
            <div className="dropdown">
              <button
                className="btn btn-light"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {permissions?.write &&
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() =>
                        navigate("../../ReturnAcceptance", {
                          state: {
                            type: row.original.type,                         // 🔹 "IR" or "PR"

                            // 🔹 IR flow
                            returnSlipCode: row.original.returnSlipCode,
                                

                            // 🔹 PR flow
                            projectRequirementId:
                              row.original.type === "PR"
                                ? row.original.projectRequirementId
                                : null,
                          },
                        })
                      }
                    >
                      <FontAwesomeIcon icon={faFileInvoice} /> Accept Return
                    </button>

                  </li>
                }
                <li>
                  <hr className="dropdown-divider" />
                </li>

                {/* Created By / Updated By */}
                <li>
                  <span className="dropdown-item-text text-muted">
                    <FontAwesomeIcon icon={faPlus} />{" "}
                    {row.original.createdBy
                      ? `${row.original.createdBy} (${row.original.created_at
                        ? moment(row.original.created_at).format(
                          "DD-MMM-YY hh:mm A"
                        )
                        : ""
                      })`
                      : ""}
                  </span>
                </li>
                {row.original.updatedAt && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faPen} />{" "}
                      {row.original.updatedAt
                        ? `${row.original.updatedBy} ${row.original?.updatedAt
                          ? moment(row.original?.updatedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        }`
                        : ""}
                    </span>
                  </li>
                )}
                {row.original.approvedBy && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      {row.original.approvedBy
                        ? `${row.original.approvedBy} ${row.original?.approvedAt
                          ? moment(row.original?.approvedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        }`
                        : ""}
                    </span>
                  </li>
                )}
              </ul>
            </div>
          ),
        }
      ],
      [permissions]
    );

    return <TableComponent columns={columns} data={pendingAcceptance} />;
  };

  const Table2 = () => {
    const completedAcceptance = React.useMemo(() => {
      return returnSlips.filter(rs => rs.status === "Accepted");
    }, [returnSlips]);


    const columns = React.useMemo(
      () => [
        { Header: 'RA Number', accessor: 'returnAcceptCode' },
        { Header: 'Requesting Department', accessor: 'receivingDepartment' },
        { Header: 'Issuing  Department', accessor: 'issuingDepartment' },
        {
          Header: "Items",
          accessor: "interDepartmentReturnSlipItems",
          Cell: ({ value }) => {
            if (!Array.isArray(value) || value.length === 0) return "-";

            return value
              .map(i => i.item || i.itemName || i.printName)
              .filter(Boolean)
              .join(", ");
          }
        },
        { Header: 'Status', accessor: 'status' },
        // { Header: 'Items', accessor: 'items' },
        {
          Header: 'Preview', accessor: 'Preview', Cell: ({ row }) => {
            return (
              permissions?.read &&
              <button
                className="btn btn-sm btn-outline-success me-1"
                onClick={() => handleReturnAcceptanceView(row.original)}
              >
                <FontAwesomeIcon icon={faEye} /> Preview

              </button>
            )
          }
        },
        {
          Header: "#",
          accessor: "actions",
          Cell: ({ row }) => (
            <div className="dropdown">
              <button
                className="btn btn-light"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {/* Conditionally render actions based on status */}
                {/* {row.original.status !== 'Approved' && (
                              <>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleSendForApproval(row.original.id)}
                                  >
                                    <FontAwesomeIcon icon={faPaperPlane} /> Send for Approval
                                  </button>
                                </li>
                              </>
                            )} */}
                {/* Always show the View option */}
                {permissions?.read &&
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleReturnAcceptanceView(row.original)}
                    >
                      <FontAwesomeIcon icon={faEye} /> Preview

                    </button>
                  </li>
                }
                <li>
                  <hr className="dropdown-divider" />
                </li>

                {/* Created By / Updated By */}
                <li>
                  <span className="dropdown-item-text text-muted">
                    <FontAwesomeIcon icon={faPlus} />{" "}
                    {row.original.createdBy
                      ? `${row.original.createdBy} (${row.original.created_at
                        ? moment(row.original.created_at).format(
                          "DD-MMM-YY hh:mm A"
                        )
                        : ""
                      })`
                      : ""}
                  </span>
                </li>
                {row.original.updatedAt && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faPen} />{" "}
                      {row.original.updatedAt
                        ? `${row.original.updatedBy} ${row.original?.updatedAt
                          ? moment(row.original?.updatedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        }`
                        : ""}
                    </span>
                  </li>
                )}
                {row.original.approvedBy && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      {row.original.approvedBy
                        ? `${row.original.approvedBy} ${row.original?.approvedAt
                          ? moment(row.original?.approvedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        }`
                        : ""}
                    </span>
                  </li>
                )}
              </ul>
            </div>
          ),
        }
      ],
      [permissions]
    );

    return <TableComponent columns={columns} data={completedAcceptance} />;
  };



  return (
    <div className="formcontainer mt-5">
      <h3>Return Acceptance</h3>
      {permissions?.read && (<>
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'table1' ? 'active' : ''}`}
              onClick={() => setActiveTab('table1')}
            >
              Pending Acceptance
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'table2' ? 'active' : ''}`}
              onClick={() => setActiveTab('table2')}
            >
              Completed Acceptance
            </button>
          </li>
        </ul>
        <div className="tab-content mt-4">
          {activeTab === 'table1' && (
            <div className="tab-pane fade show active">
              <Table1 />
            </div>
          )}
          {activeTab === 'table2' && (
            <div className="tab-pane fade show active">
              <Table2 />
            </div>
          )}
        </div>
      </>)}
    </div>
  );
};

export default ReturnAcceptanceTable;
